<template>
  <div class="mx-2">
    <Summary></Summary>
  </div>
</template>

<script>


import Summary from "./components/Summary.vue";

export default {
  name: 'Sales',
  components: {
    Summary
  },

  data() {
    return {};
  },

  created() {

  },

  methods: {},
};
</script>
